var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "850",
      "title": _vm.customerName
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "info-item"
  }, [_c('h3', [_vm._v("客户")]), _c('div', [_vm._v(_vm._s(_vm.customerName ? _vm.customerName : ""))])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h3', [_vm._v("应收总额")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedAR.totalAccountsReceivable ? _vm.openedAR.totalAccountsReceivable.toLocaleString() : "") + " ")])]), _c('div', {
    staticClass: "info-item"
  }, [_c('h3', [_vm._v("逾期总额")]), _c('div', [_vm._v(" " + _vm._s(_vm.openedAR.totalPastDueAR ? _vm.openedAR.totalPastDueAR.toLocaleString() : "") + " ")])]), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper-ar"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.openedAR.arTable ? _vm.openedAR.arTable : [],
      "loading": _vm.tableLoading,
      "border": ""
    }
  })], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper-receive"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.receiveColumns,
      "data": _vm.receiveList,
      "loading": _vm.tableLoading,
      "border": ""
    },
    scopedSlots: _vm._u([{
      key: "amount",
      fn: function (_ref) {
        var row = _ref.row,
          column = _ref.column,
          index = _ref.index;
        return [row.amount ? _c('div', [_vm._v(_vm._s(Number(row.amount).toLocaleString("zh", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })) + " ")]) : _c('div', [_vm._v(_vm._s(row.submitAmount)), _c('Icon', {
          staticStyle: {
            "position": "relative",
            "top": "-2px"
          },
          attrs: {
            "type": "md-help"
          }
        })], 1)];
      }
    }])
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }